import { Routes, Route } from 'react-router-dom-v5-compat'
import { useDispatch, useSelector } from 'react-redux'
import { getUserFields } from 'registry/modules/onboarding/reducers'
import { KidNameAndBirthdate } from '../../components/KidNameAndBirthdate/KidNameAndBirthdate'
import { CelebrateAge } from '../../components/CelebrateAge/CelebrateAge'
import {
  ClothingSizes,
  SIZE_KEYS,
} from '../../components/ClothingSizes/ClothingSizes'
import { WishlistPreferences } from '../../components/WishlistPreferences/WishlistPreferences'
import BirthdayCreate from '../../components/BirthdayCreate/BirthdayCreate'
import { createRegistry } from '../../api'
import { setUserResponse } from '../../actions'

const RELATIVE_PATHS = {
  BIRTHDAY_WISHLIST: '',
  BIRTHDAY_CELEBRATE_AGE: 'celebrate',
  BIRTHDAY_CLOTHING_SIZES: 'clothing-sizes',
  BIRTHDAY_PREFERENCES: 'preferences',
  BIRTHDAY_CREATE: 'create',
}

export const PATHS = (() => {
  const temp = { ...RELATIVE_PATHS }
  let key: keyof typeof RELATIVE_PATHS
  for (key in temp) {
    temp[key] = `/birthday/${temp[key]}`
  }

  return temp
})()

export const BirthdayFlow = () => {
  const userData = useSelector((state: any) => getUserFields(state))
  const dispatch = useDispatch()

  const handleSetUserResponse = (data: any) => {
    dispatch(setUserResponse(data))
  }

  return (
    <Routes>
      <Route
        path={RELATIVE_PATHS.BIRTHDAY_WISHLIST}
        element={
          <KidNameAndBirthdate
            initialBirthdate={userData?.birthdate}
            initialFirstName={userData?.first_name}
            initialPhotoUrl={userData?.registry?.photo_url}
            nextPath={PATHS.BIRTHDAY_CELEBRATE_AGE}
            onSubmit={handleSetUserResponse}
            title="Tell us about this wonderful person!"
          />
        }
      />
      <Route
        path={RELATIVE_PATHS.BIRTHDAY_CELEBRATE_AGE}
        element={
          <CelebrateAge
            birthdate={userData?.birthdate}
            nextPath={PATHS.BIRTHDAY_CLOTHING_SIZES}
          />
        }
      />
      <Route
        path={RELATIVE_PATHS.BIRTHDAY_CLOTHING_SIZES}
        element={
          <ClothingSizes
            initialSelectedOptions={{
              [SIZE_KEYS.CLOTHING]: userData?.clothing_size,
              [SIZE_KEYS.SHOE]: userData?.shoe_size,
            }}
            nextPath={PATHS.BIRTHDAY_PREFERENCES}
            onSubmit={handleSetUserResponse}
          />
        }
      />
      <Route
        path={RELATIVE_PATHS.BIRTHDAY_PREFERENCES}
        element={
          <WishlistPreferences
            firstName={userData?.first_name}
            initialValues={{
              preferences: userData?.preferences || [],
              favorite_color: userData?.favorite_color || '',
            }}
            nextPath={PATHS.BIRTHDAY_CREATE}
            onSubmit={handleSetUserResponse}
          />
        }
      />
      <Route
        path={RELATIVE_PATHS.BIRTHDAY_CREATE}
        element={
          <BirthdayCreate
            handleSetUserResponse={handleSetUserResponse}
            onboardingUserData={userData}
            onSubmit={createRegistry}
          />
        }
      />
    </Routes>
  )
}
